import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { Contract } from 'app/models/contract.model';
import { ConfirmationDialogComponent } from 'app/services/user-interaction/components/confirmation-dialog/confirmation-dialog.component';
import { cloneDeep } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';

import { BaseFormComponent } from '../../base-form.component';
import { ContractFormComponent } from '../contract-form/contract-form.component';
import { ContractService } from './../../../../../services/contract.service';
import { ToasterService } from './../../../../../services/user-interaction/services/toaster.service';
import { CompanyListComponent } from './../company-list/company-list.component';

@Component({
    selector: 'app-contract-list',
    templateUrl: './contract-list.component.html',
    styleUrls: ['./contract-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class ContractListComponent extends BaseFormComponent implements OnInit {
    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    constructor(
        private _dialog: MatDialog,
        private _contractService: ContractService,
        private _spinner:NgxSpinnerService,
        public dialogRef: MatDialogRef<CompanyListComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
        private _toasterService: ToasterService,
        private _translateService:TranslateService
    ) {
        super();
    }

    private _contractList: Array<Contract>;
    public get contractList() {
        return this._contractList;
    }

    private _dataSource: MatTableDataSource<Contract> = undefined;
    public get dataSource(): MatTableDataSource<Contract> {
        return this._dataSource;
    }

    private _displayedColumns = ['description', 'startDate', 'endDate', 'status', 'setting'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }
    public async ngOnInit() {
        await this.getContract();
    }

    public async getContract() {

        try {
            this._spinner.show('loading')
            this._contractList = await this._contractService.getContracts(this.data.id);
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
        await this.updateTableDataSource();
    }
    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<Contract>(this._contractList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    contractAdd() {
        const dialog = this._dialog.open(ContractFormComponent,
            {
                data: cloneDeep(this.data),
                disableClose: false,
                width:"800px"
            })
        dialog.componentInstance.added.subscribe((model: boolean) => {
            model ? this._toasterService.toastSuccess() : this._toasterService.toastFail();
            this.refresh();
            dialog.close();
        });

    }
    async deleteContract(contract: Contract) {
        try {
            const dialog = this._dialog.open(ConfirmationDialogComponent,{

            })
            dialog.componentInstance.message = "Seçilen sözleşmeyi silmek istediğinize emin misiniz?"
            dialog.componentInstance.confirmed.subscribe(async(x)=>{
                await this._contractService.delete(contract);
                dialog.close();
            })
            dialog.componentInstance.rejected.subscribe(async (x:any) => {
                dialog.close();
            })
            
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            this._toasterService.toastFail();
        }
        this.refresh();
    }

    async ContractStatusChange(contract: Contract) {
        contract.status = !contract.status
        var statusControl = this.contractList.filter(e => e.status == true);
        if (statusControl.length > 1) {
            this._toasterService.toastWarning(this._translateService.instant("THERE_IS_ALREADY_AN_ACTIVE_CONTRACT"))
            contract.status = !contract.status
            return;
        }
        try {
            await this._contractService.updated(contract);
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
        this.refresh();
    }
    refresh() {
        this.getContract();
    }
}
